import { render, staticRenderFns } from "./formUpload.vue?vue&type=template&id=310d5dc7&scoped=true"
import script from "./formUpload.vue?vue&type=script&lang=js"
export * from "./formUpload.vue?vue&type=script&lang=js"
import style0 from "./formUpload.vue?vue&type=style&index=0&id=310d5dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310d5dc7",
  null
  
)

export default component.exports